<div
    role="alert"
    class="info my-0"
    *ngIf="!(hideProTip$ | async)"
    [@fadeInOut]
    [class.w-container]="fitToContainer"
>
    <header>
        <h3 class="h4 mb-0">{{ heading }}</h3>
    </header>
    <main>
        <ng-content></ng-content>
    </main>
    <footer class="justify-content-between" *ngIf="!(alwaysVisible$ | async)">
        <mat-checkbox
            class="mb-3 mb-sm-0 me-sm-2 text-center text-sm-start"
            #dontShowAgain
        >
            Don't show this again
        </mat-checkbox>
        <button
            type="button"
            class="btn btn-sm secondary text-nowrap"
            (click)="hideProTip(dontShowAgain.checked)"
        >
            {{ dismissButtonText }}
        </button>
    </footer>
</div>
